/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ProgramGroup } from "./ProgramGroup";
import type { ProgramID } from "./ProgramID";

/**
 * The care program + track a visit was created under, forwarded to the EMR.
 *
 * Mirrors the gateway's universal-clinic Program contract so new-api can store
 * the visit's ACCESS program indication at the encounter level.
 */
export interface VisitProgram {
  /** The care program group the visit belongs to. */
  group: ProgramGroup;
  /** The program type/track within the group. */
  type: ProgramID;
}
